import { render, staticRenderFns } from "./createMiniCouerse.vue?vue&type=template&id=206c3742&scoped=true"
import script from "./createMiniCouerse.vue?vue&type=script&lang=js"
export * from "./createMiniCouerse.vue?vue&type=script&lang=js"
import style0 from "./createMiniCouerse.vue?vue&type=style&index=0&id=206c3742&prod&lang=less&scoped=true"
import style1 from "./createMiniCouerse.vue?vue&type=style&index=1&id=206c3742&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c3742",
  null
  
)

export default component.exports